export default "__VITE_ASSET__Dup3aRHC__"